import { Component, OnInit } from '@angular/core';
import { CookieSnackbarService } from '../../services/cookie-snackbar.service';
import { BrandService } from '../../services/brand.service';

@Component({
  selector: 'app-cookie-snackbar',
  templateUrl: './cookie-snackbar.component.html',
  styleUrls: ['./cookie-snackbar.component.scss']
})
export class CookieSnackbarComponent implements OnInit {
  privacyPolicyLink: string;

  constructor(private cookieSnackbarService: CookieSnackbarService, private brandService: BrandService) {
    this.privacyPolicyLink = this.brandService.brand.privacyPolicyLink;
  }

  ngOnInit(): void {}

  close() {
    this.cookieSnackbarService.close();
  }
}
